import { Button } from './ui/button';
import { Info } from 'lucide-react';

interface VersionDisplayProps {
  onNavigate: () => void;
}

export function VersionDisplay({ onNavigate }: VersionDisplayProps) {
  const currentVersion = "V1.4.4";
  
  return (
    <Button 
      variant="ghost" 
      size="sm" 
      className="w-full justify-start text-muted-foreground hover:text-foreground"
      onClick={onNavigate}
    >
      <Info className="mr-2 h-3 w-3" />
      {currentVersion}
    </Button>
  );
}